'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../themes/alert.js');
var borders = require('../../../../themes/borders.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
var baseLink = require('../base-link/base-link.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseStandardLink = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { className , disabled , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement(baseLink.BaseLink, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-link__standard': true,
            'bf-link__standard--disabled': disabled,
            [`${className}`]: className
        }),
        disabled: disabled,
        ref: ref
    }));
});
const Link = styled__default.default(BaseStandardLink)`
  border-radius: ${borders.borderRadiusMedium}px;
  color: ${({ theme  })=>theme.link.textColor};
  display: inline-block;
  text-decoration: underline;

  &:hover {
    color: ${({ theme  })=>theme.link.textColorHover};
  }

  &:active {
    color: ${({ theme  })=>theme.link.textColorActive};
  }

  &:focus {
    outline: 0;
  }

  &:focus-visible {
    color: ${({ theme  })=>theme.link.textColorFocus};
    outline: 2px solid ${({ theme  })=>theme.link.outlineColorFocus};
    outline-offset: 2px;
  }

  &[aria-disabled='true'] {
    color: ${({ theme  })=>theme.link.textColorDisabled};
    cursor: not-allowed;
  }
`;
const StandardLink = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Link, _extends({}, props, {
        ref: ref
    })));
});

exports.BaseStandardLink = BaseStandardLink;
exports.StandardLink = StandardLink;
//# sourceMappingURL=standard-link.js.map
